import React from 'react';
import './demo.css';

const Demo = () => {
  return (
    <div class="demo wrapper">
        <div class="demo__content-title">
            <h3>Experience the Power of Our Live Chat</h3>
            <p>See for yourself how our live chat can help you connect with your customers and improve their experience on your website. Check out a screenshot of our live chat in action.</p>
            <a href="#home" className="btn--demo">Book a Demo</a>
            <div class="demo__content-title-item">
                <div>
                    <h4>Improving Customer Support</h4>
                    <p>A small e-commerce company implemented a live chat feature on their website and saw an improvement in customer satisfaction and an increase in sales.</p>
                </div>
                <div>
                    <h4>Boosting Sales</h4>
                    <p>A small e-commerce company implemented a live chat feature on their website and saw an improvement in customer satisfaction and an increase in sales.</p>
                </div>
            </div>
        </div>
        <div class="demo__content-image">
        </div>
    </div>
  )
}

export default Demo